export const DefaultTranslations = {
  appFrame: {
    mainMenu: {
      home: "Home",
      adminConsole: "Admin Console",
      certificates: "Certificates",
    },
    navbar: {
      viewProfile: "View Profile",
      logOut: "Log Out",
      mobileSelectLanguageHeader: "Select a language",
    },
  },
  home: {
    header: {
      welcomeBack: "Welcome back",
      activeAssignments: "Active assignments",
      homeBreadcrumbLabel: "Home",
    },
    assignments: {
      myAssignments: "My assignments",
      filter: "Filter",
      filtersApplied: "Filters applied",
      clearAll: "Clear all",
      overdue: "Overdue",
      preview: "Preview",
      courses: "Courses",
      surveys: "Surveys",
      policies: "Policies",
      locked: "Locked",
      assignmentRequired: "assignment required",
      durationMinutes: "Duration: {duration} mins",
      assignmentsRequired: "assignments required",
    },
    filters: {
      filtersTitle: "Filters",
      groups: "Groups",
      all: "All",
      progressStatusTitle: "Progress Status",
      notStarted: "Not Started",
      inProgress: "In Progress",
      failed: "Failed",
      notStartedOverdue: "Not Started (Overdue)",
      inProgressOverdue: "In Progress (Overdue)",
      completedOverdue: "Completed (Overdue)",
      assignmentTypeTitle: "Assignment Type",
      course: "Course",
      policy: "Policy",
      survey: "Survey",
      importanceTitle: "Importance",
      required: "Required",
      optional: "Optional",
      save: "Save",
      clearAll: "Clear all",
    },
    banner: {
      total: "Total",
      completed: "Completed",
      pending: "Pending",
      overdue: "Overdue",
      assignmentsCompletedLabel: "Assignments completed",
      averageScoreLabel: "Average score",
      minutesOfLearningLabel: "Minutes of learning",
      mobileFold: "Fold",
      mobileExpand: "Expand",
    },
    modalLockedAssignment: {
      prerequisitesTitle: "Assignments required",
      prerequisitesDescription:
        "To unlock this course, please complete the required assignments:",
      completedOfTotal: "{completed} of {total} completed",
      whatsNeeded: "What's needed",
      openAssignment: "Open assignment",
      seeRequirements: "See requirements",
      close: "Close",
    },
  },
  login: {
    loginHeader: {
      loginText: "Log in",
      loginDsc: "Please login here to access your training portal",
    },
    loginForm: {
      email: "Email",
      emailPlaceholder: "Enter your email address",
      password: "Password",
      btnForgotPassword: "Forgot password?",
      btnLogin: "Log in",
    },
    loginMessages: {
      emailInvalid: "Enter a valid email",
      passwordRequired: "Enter a password",
    },
    footer: {
      poweredBy: "Powered by",
    },
  },
  "forgot-password": {
    forgotPasswordHeader: {
      forgotPasswordText: "Forgot password?",
      forgotPasswordDsc: "No worries, we'll send you reset instructions.",
    },
    forgotPasswordForm: {
      email: "Email",
      emailPlaceholder: "Enter your email address",
      btnReset: "Reset password",
      backTologin: "Back to log in",
    },
    forgotPasswordInfo: {
      checkMailText: "Check your email",
      checkMailDsc: "We sent a password reset link to",
      notReceive: "Didn't receive the email?",
      clickToResend: "Click to resend",
    },
    forgotPasswordMessages: {
      emailInvalid: "Enter a valid email address.",
    },
  },
  "new-password": {
    setNewPasswordHeader: {
      setNewPasswordText: "Set new password",
      setNewPasswordDsc:
        "Your new password must be different to previously used passwords.",
    },
    setNewPasswordForm: {
      newPassword: "New password",
      repeatPassword: "Repeat password",
      criteria1: "Must be at least 8 characters",
      criteria2: "Must contain one lowercase letter",
      criteria3: "Must contain one uppercase letter",
      criteria4: "Must contain special characters: !@#$%*",
      btnReset: "Reset password",
    },
    passwordReset: {
      passwordResetText: "Password Reset",
      passwordResetDsc:
        "Your password has been successfully reset. Click below to log in magically.",
      btnLogin: "Log in",
      btnBackToLogin: "Back to log in",
    },
    setNewPasswordMessages: {
      passwordRequirementsNotMet:
        "You must meet all the requirements for password",
      passwordsDontMatch: "Passwords must match",
    },
    activateAccountForm: {
      activateAccount: "Activate your account",
      activateAccountDsc:
        "Please enter the necessary information to be able to enter this platform.",
      btnActivate: "Activate account",
    },
  },
  "link-expired": {
    linkExpiredHeader: {
      linkExpiredText: "Link expired",
      linkExpiredDsc:
        "Your invitation link is no longer valid. Send yourself a new one to continue.",
    },
    linkExpiredForm: {
      btnResendInvitation: "Resend Invitation",
      btnBackToLogin: "Back to log in",
    },
  },
  "assignment-detail": {
    courseContentTab: {
      courseContent: "Course content",
      percentComplete: "{percentage}% Complete",
    },
    notesTab: {
      notes: "Notes",
      editNote: "Edit Note",
      removeNote: "Remove Note",
      noteRemoved: "Note Removed",
      undo: "Undo",
      noteRemovedExpiry: "This note will disappear in 1 hr",
      noteEdited: "Note edited",
      enterNotesPlaceholder: "Enter notes",
    },
    header: {
      previewBadge: "Preview",
    },
    acknowledgmentLocked: {
      tabLabel: "Acknowledgement",
      lockedTitle: "Acknowledgement locked",
      unlockHintVideo: "Watch the full video to unlock this section.",
      unlockHintPdf: "View all {pages} pages to unlock this section.",
      lockedTooltip: "Acknowledgment - locked until you finish",
    },
    acknowledgmentRequired: {
      requiredTitle: "Acknowledgement required",
      requiredTooltip: "Acknowledgment - response required",
      unlockedSubtitle:
        "Please confirm your response before completing this assignment.",
      acceptLabel: "I acknowledge and understand this content",
      declineLabel: "I do not acknowledge this content",
      commentLabel: "Comment",
      commentTooltip:
        "Required if you decline, optional if you acknowledge.",
      commentPlaceholder: "Add a comment...",
      submitResponseButton: "Submit response",
      acceptLabelTipico: "Yes, I acknowledge and agree",
      acceptLabelQuestionsTipico:
        "Yes, I acknowledge and agree, but I have some questions",
    },
    acknowledgmentSubmitted: {
      submittedTitle: "Acknowledgement submitted",
      submittedSubtitle:
        "Your response has been recorded and cannot be changed.",
    },
    acknowledgmentNotRequired: {
      notRequiredTitle: "Acknowledgement not required",
      notRequiredSubtitle:
        "This assignment was completed before acknowledgement was required, so no response is needed.",
    },
    acknowledgmentPageByPage: {
      pdfNavLocked: "View all pages to unlock acknowledgement and complete.",
      previousLabel: "Previous",
      pdfNavDefault: "View all pages to complete the assignment.",
      nextLabel: "Next page",
      searchPlaceholder: "Search in document",
      currentOfTotal: "Page {current} of {total}"
    },
    modalMaxAttemptsLimit: {
      title: "No attempts remaining",
      description:
        "You have exceeded the maximum number of attempts. This assignment cannot currently be completed. Please contact your administrator to request additional attempts.",
      goBack: "Go back",
    },
  },
  errorPage: {
    messages: {
      accessDeniedTitle: "Access denied",
      accessDeniedSubtitle:
        "Sorry, you don't have the required permissions to access this resource.",
      notFoundTitle: "Page not found",
      notFoundSubtitle:
        "Sorry, the page you are looking for doesn't exist or has been moved.",
      goBack: "Go back",
      goToHomepage: "Go to homepage",
    },
  },
  certificates: {
    page: {
      title: "Certificates",
      searchPlaceholder: "Search by name",
      selectedCertificates: "Selected certificates",
      download: "Download",
      assignment: "Assignment",
      type: "Type",
      startDate: "Start date",
      completionDate: "Completion date",
      timeSpent: "Time spent",
      bestScore: "Best score",
      all: "All",
      showRows: "Show rows",
      previous: "Previous",
      next: "Next",
    },
    certificateView: {
      certificateOfCompletion: "Certificate of Completion",
      attainedCompetency: "has successfully attained competency in",
      score: "Score",
      duration: "Duration",
      certificateId: "Certificate ID",
      hour: "hour",
      min: "min",
      hours: "hours",
      mins: "mins",
    },
  },
  "my-profile": {
    page: {
      title: "My Profile",
      personalInfoTitle: "Personal info",
      firstName: "First name",
      firstNamePlaceholder: "Enter your first name",
      lastName: "Last name",
      lastNamePlaceholder: "Enter your last name",
      emailAddress: "Email address",
      resetPassword: "Reset Password",
      uploadPhoto: "Upload photo",
      uploading: "Uploading...",
      myDetailsTitle: "My details",
      noAttributes: "No additional attributes available.",
      saveChanges: "Save Changes",
      saving: "Saving...",
    },
    resetPasswordModal: {
      title: "Reset password",
      description:
        "Please enter your current password to change your password.",
      currentPassword: "Current Password",
      currentPasswordPlaceholder: "Enter your current password",
      newPassword: "New Password",
      newPasswordPlaceholder: "Enter your new password",
      confirmNewPassword: "Confirm new Password",
      confirmPasswordPlaceholder: "Confirm your new password",
      criteria1: "Must be at least 8 characters",
      criteria2: "Must contain one lowercase letter",
      criteria3: "Must contain one uppercase letter",
      criteria4: "Must contain special characters: !@#$%*",
      cancel: "Cancel",
      updatePassword: "Update password",
    },
    messages: {
      currentPasswordRequired: "Current password is required",
      newPasswordRequired: "New password is required",
      confirmPasswordRequired: "Please confirm your new password",
      passwordsDontMatch: "Passwords do not match",
       passwordRequirementsNotMet: "Password must meet all requirements",
    },
  },
} as const;
